@if (streams$ | async; as streams) {
    <button mat-menu-item [matMenuTriggerFor]="moveMenu">
        <mat-icon>{{ copy ? "content_copy" : "content_cut" }}</mat-icon>
        <span>{{ copy ? "Copy" : "Move" }}</span>
    </button>
    <mat-menu #moveMenu="matMenu">
        @for (stream of streams; track stream) {
            <span>
                @if (stream.children && stream.children.length > 0) {
                    <span>
                        <button
                            mat-menu-item
                            [matTooltip]="stream.description"
                            [matMenuTriggerFor]="childMenu"
                            (click)="action(assets, stream.id, streamId)"
                        >
                            <mat-icon>collections</mat-icon>
                            <span>{{ stream.name }}</span>
                        </button>
                        <mat-menu #childMenu="matMenu" [overlapTrigger]="false">
                            @for (child of stream.children; track child) {
                                <span>
                                    <!-- Handle leaf node menu items -->
                                    <button
                                        mat-menu-item
                                        [matTooltip]="child.description"
                                        (click)="action(assets, child.id, streamId)"
                                    >
                                        <mat-icon>collections</mat-icon>
                                        <span>{{ child.name }}</span>
                                    </button>
                                </span>
                            }
                        </mat-menu>
                    </span>
                } @else {
                    <button
                        mat-menu-item
                        [matTooltip]="stream.description"
                        (click)="action(assets, stream.id, streamId)"
                    >
                        <mat-icon>collections</mat-icon>
                        <span>{{ stream.name }}</span>
                    </button>
                }
                <ng-template #leaf>
                    <button
                        mat-menu-item
                        [matTooltip]="stream.description"
                        (click)="action(assets, stream.id, streamId)"
                    >
                        <mat-icon>collections</mat-icon>
                        <span>{{ stream.name }}</span>
                    </button>
                </ng-template>
            </span>
        }
    </mat-menu>
}
